import { V_FORM_ENUM } from '../utils';
import { openUser } from "@/CommonDP/components/custom-dialog";
import personInfoService from "@/CommonDP/service/admin/personInfo-service.js";
import priviService from "@/CommonDP/service/privi-service";
import orgFrameworkConfigService from '@/CommonDP/service/admin/orgFrameworkConfig-service';
import Vue from "vue";
import personService from "@/CommonDP/service/personPlan-service.js";
import prjUserService from "@/CommonDP/service/doc-service.js";
export const USER_ENUM = {
  user: '{user}',
  dept: '{dept}',
  prj: '{project}',
  role: '{role}',
  specRole: '{specialRole}',
  frameWork: '{all}',
  cur_dept: '{currentDept}',
  cur_user: '{currentUser}',
  specified_user: '{all}',
  range_all: '{range_all}'
};

// 人员选择基础Schema
export const baseSchema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-user',
  icon: 'tree',
  label: '人员列表',
  formItemFlag: true,
  props() {
    return {
      setting: () => import('./setting.vue')
    };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onValidate: ['rule', 'value', 'callback']
    };
  },
  getSFC: () => {
    return '<div></div>';
  },
  zh: {
    user: {
      label: '标签名称',
      showUserName: '显示工号',
      avatar: '显示头像',
      candateValues: '人员范围'
    }
  },
  options: {
    name: '',
    line: 'block',
    label: '人员列表',
    requiredHint: ' ',
    labelHidden: false,
    labelWidth: '',
    labelWrap: false, // 自动换行
    required: false,
    position: '',
    customClass: '',
    disabled: false,
    labelAlign: '',
    labelPosition: '',
    columnWidth: '200px',
    // ----------
    setting: true,
    single: false,
    onMounted: '',
    showAvatar: true,
    showUserName: true,
    // 人员 默认值
    defaultUserType: USER_ENUM.specified_user,
    defaultUser: [],
    // 人员范围
    candateRangeType: USER_ENUM.range_all,
    candateValues: [],
    // -------
    onValidate: '',
    onChange: '',
    onInitAndUpdate: ''
  }
};

export async function open_Custom_SysRole({ data, enterpriseId, candateValues = [], max }) {
  const tab = {
    data,
    label: "系统角色",
    id: "custom-role",
    async get(node) {
      const isRoot = !node.level;
      let list;
      if (!isRoot) {
        const { key: roleId, label: roleName } = node;
        const params = { roleId, enterpriseId, roleName };
        const { data } = await priviService.getSysRoleUserList(params);
        list = data.map((raw) => ({ raw, leaf: true, id: raw.userId, label: raw.name, icon: "el-icon-user" }));
      } else {
        list = candateValues.map((raw) => ({ raw, leaf: false, id: raw.roleID, label: raw.roleName }));
      }
      return list;
    }
  };
  return await openUser({
    title: "选择人员", max,
    getTabs: () => [tab]
  });
}
async function treeCache(treeService, formatFn, getChildren) {
  const pidKey = Symbol();
  const levelKey = Symbol();
  const { data } = await treeService;
  const cache = [].concat(data);
  const formatList = [];
  for (const dept of cache) {
    const format = formatFn(dept);
    format[pidKey] = dept[pidKey];
    format[levelKey] = dept[levelKey] || 0;
    const children = getChildren(format);
    formatList.push(format);
    if (children) {
      for (const c of children) {
        c[pidKey] = format.id;
        c[levelKey] = format[levelKey] + 1;
      }
      children && cache.push(...children);
    }
  }
  return (id) => formatList.filter((item) => item[pidKey] === id);
}
export async function open_Frame_User({ data, max, enterpriseId }) {
  const cache_dept = [];
  const tab = {
    data,
    label: "组织架构",
    id: 'frame-work',
    async get(node) {
      const isRoot = !node.level;
      const list = [];
      const pid = node.key || '0';
      if (isRoot) {
        const { data } = await orgFrameworkConfigService.getOrgTree(enterpriseId);
        cache_dept.push(...data);
        for (const dept of cache_dept) {
          const { children } = dept;
          children && cache_dept.push(...children);
        }
      }
      const deptList = cache_dept
        .filter(({ parentDeptId }) => parentDeptId === pid)
        .map((dept) => ({
          id: dept.deptId,
          label: dept.deptName,
          raw: dept,
          leaf: false
        }));
      list.push(...deptList);
      if (!isRoot) {
        const { data: users } = await orgFrameworkConfigService.orgUserList({
          deptId: pid,
          pageNum: 1,
          pageSize: 999,
          enterpriseId,
          isQueryAll: 0
        });
        const userList = users.map((user) => ({
          id: user.userId,
          label: user.name,
          raw: user,
          leaf: true,
          icon: "el-icon-user"
        }));
        list.push(...userList);
      }
      return list;
    }
  };
  return await openUser({
    max,
    title: "组织架构",
    getTabs: () => [tab]
  });
}
export async function open_Custom_Dept_User({ data, max, enterpriseId, candateValues = [] }) {
  const tab = {
    data,
    label: "单位选择",
    id: 'custom-dept',
    async get(node) {
      const isRoot = !node.level;
      let list = [];
      const pid = node.key || '0';
      if (isRoot) {
        list = candateValues.map((raw) => ({ raw, leaf: false, id: raw.userId, label: raw.name }));
      } else {
        const { data: users } = await orgFrameworkConfigService.orgUserList({
          deptId: pid,
          pageNum: 1,
          pageSize: 999,
          enterpriseId,
          isQueryAll: 0
        });
        list = users.map((user) => ({
          id: user.userId,
          label: user.name,
          raw: user,
          leaf: true,
          icon: "el-icon-user"
        }));
      }
      return list;
    }
  };
  return await openUser({
    title: "人员选择",
    max,
    getTabs: () => [tab]
  });
}

export async function open_Prj_User({ data, prjId, max, enterpriseId }) {
  const service = prjUserService.queryRoleListNew(prjId, enterpriseId);
  const getList = await treeCache(service, (raw) => {
    return {
      raw,
      leaf: false,
      icon: "el-icon-notebook-2",
      id: raw.roleId || raw.specId || raw.prjId,
      label: raw.roleName || raw.specName || raw.prjName
    };
  }, (data) => {
    return data.raw.childList;
  });
  const tab = {
    data,
    label: "项目选择",
    id: 'custom-prj',
    async get(node) {
      const userLevel = node.level === 3;
      const pid = node.key || undefined;
      if (userLevel) {
        const { data: { raw: { roleId, specId }}} = node;
        const { data: list } = await personService.queryPersonList({
          prjId,
          roleId,
          specId,
          enterpriseId
        });
        return list.map((user) => ({
          id: user.userId,
          label: user.name,
          raw: user,
          leaf: true,
          icon: "el-icon-user"
        }));
      } else {
        return getList(pid || undefined);
      }
    }
  };
  return await openUser({
    title: "人员选择",
    max,
    getTabs: () => [tab]
  });
}

// 人员store
// key:id  value:人员信息
export const user_cache = Vue.observable({});
// 正在请求的接口
const waitMap = {};
export async function getUserById(id) {
  // 是否已加载完毕
  const user = user_cache[id];
  // 是否正在加载
  const wait = waitMap[id];
  if (user) {
    return user;
  } else if (wait) {
    return wait;
  } else {
    const fn = personInfoService.queryCommonUserInfo(id).then(({ data }) => {
      const { userId, userName, name } = data;
      const user = { name, userId, username: userName };
      Vue.set(user_cache, userId, user);
      waitMap[userId] = undefined;
      return user;
    });
    waitMap[id] = fn;
    return fn;
  }
}
